var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_6262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43694 6.56243L6.56194 3.43743M2.33069 4.13118L1.66819 4.79368C1.19909 5.26278 0.935547 5.89902 0.935547 6.56243C0.935547 7.22584 1.19909 7.86207 1.66819 8.33117C2.13729 8.80028 2.77353 9.06382 3.43694 9.06382C4.10035 9.06382 4.73659 8.80028 5.20569 8.33117L5.86819 7.66868M7.66819 5.86868L8.33069 5.20618C8.79979 4.73707 9.06333 4.10084 9.06333 3.43743C9.06333 2.77402 8.79979 2.13778 8.33069 1.66868C7.86158 1.19957 7.22535 0.936035 6.56194 0.936035C5.89853 0.936035 5.26229 1.19957 4.79319 1.66868L4.13069 2.33118",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_6262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.7e621e54b7258a65279a3d697d5d2ae6.svg";
export { ForwardRef as ReactComponent };